// MARK: React
import * as React from "react";
import { observer, inject } from "mobx-react";
import "./style.scss";

// MARK: Components
import GastroPlacesTable from "./GastroPlacesTable";
import GastroPlaceCreateOrEdit from "./GastroPlaceCreateOrEdit";

// MARK: Router
import { Route, Switch } from "react-router-dom";

// MARK: Stores
import AuthStore from "../../../stores/AuthStore";

interface IProps {
	authStore: AuthStore;
}

@inject("authStore")
@observer
export default class GastroPlaces extends React.Component<IProps> {
	public componentDidMount = async () => {
		await this.props.authStore.authenticate();
	};

	public render() {
		return (
			<div className="gastroPlaces">
				<Switch>
					<Route exact={true} path="/dashboard/gastroPlaces/editor" component={GastroPlaceCreateOrEdit} />
					<Route path="/dashboard/gastroPlaces/editor/:gastroPlaceId" component={GastroPlaceCreateOrEdit} />
					<Route path="/dashboard/gastroPlaces" component={GastroPlacesTable} />
				</Switch>
			</div>
		);
	}
}
